import React from 'react';
import PropTypes from 'prop-types';
import CMService from 'services/CMS';
import TagManagerService from 'services/TagManager';
import Items from 'components/Home/FeaturedWithButton/Items';
import style from './style.scss';//NOSONAR

let gtmData = [];

const FeaturedWithButton = (props) => {
    const itemData = props.data ? props.data : null;

    let itemsActive = itemData && itemData.banner_offer.filter(element => {
        if(!element.title || !element.description) return ''

        return element.active && CMService.validDatesItem(element, itemData.serverDate)
    }).slice(0, 4);

    if(!(itemData && itemData.title) || itemsActive.length < 4) return '';

    const sliderItems = (data) => {
        let pos = 0;
        
        let items = data.map((item, i) => {
            pos++

            gtmData.push({
                id: item.imagen.url,
                name: item.imagen.url,
                creative: 'Destacados con botón administrable ' + itemData.featuredWithButton + ' - ' + itemData.title,
                position: 'slot' + pos,
            })
            
            return (
                <Items item={item} key={i} nameGrid={itemData.title} positionGrid={itemData.featuredWithButton}/> 
            )
        });

        TagManagerService.promotionsImpressions(gtmData);

        return items
    }

    return (
        <div className="featured-with-button">
            <h3 className="featured-with-button-title">{itemData.title}</h3>

            <div className="featured-button-items-wrap">
                {sliderItems(itemsActive)}
            </div>
        </div>
    )
}

FeaturedWithButton.propTypes = {
    data: PropTypes.object
}

export default FeaturedWithButton;
